import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Card = styled(Box)(() => ({
  backgroundColor: protoColors.surface,
  border: `1px solid ${protoColors.border}`,
  borderRadius: '16px',
  padding: '20px 22px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const Header = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
}));

export const Title = styled(Typography)(() => ({
  fontSize: '17px',
  fontWeight: 700,
  color: protoColors.textPrimary,
}));

export const Subtitle = styled(Typography)(() => ({
  fontSize: '13px',
  color: protoColors.textMuted,
}));
